
import { Vue, Component, Prop } from 'vue-property-decorator'

import CustomWrapper from '@/components/CustomWrapper.vue'

const config = {
  name: 'c-poi-mini-card-title',
  components: { CustomWrapper }
}

@Component(config)
export default class CPoiMiniCardTitle extends Vue {

  @Prop({ type: String, default: 'div' }) tag!: string

}
